import { SupportTaskKind } from '@duke-hq/svc-api-db/client';

export const SYDNEY_TZ = 'Australia/Sydney';

export const NYB_TASK_KINDS: readonly SupportTaskKind[] = [
  SupportTaskKind.NYB_CALL,
  SupportTaskKind.NYB_SMS,
  SupportTaskKind.NYB_EMAIL,
];

export const CALL_TASK_KINDS: readonly SupportTaskKind[] = [
  SupportTaskKind.WELCOME_CALL,
  SupportTaskKind.NYB_CALL,
  SupportTaskKind.WITHDRAWAL_WARNING_STUDENT_CALL,
];
